const map = () => import("../../views/kashiMarathon/map.vue");

const router = {
    path: '/marathon',
    name: 'Marathon',
    component: map,
    meta: {
        title:"KSMLS"
    }
}

export default router;


// WEBPACK FOOTER //
// ./src/router/modules/marathon.js